import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const ForgotPasswordSchema = z.object({
  email: z
    .string({
      required_error: i18nMessage("shared:forms.forgotPassword.emailRequired"),
      invalid_type_error: i18nMessage("shared:forms.forgotPassword.emailInvalidType"),
    })
    .email(i18nMessage("validation:invalidEmail")),
});

export type ForgotPasswordFormData = z.infer<typeof ForgotPasswordSchema>;
